import { configureCompat } from 'vue'

configureCompat({
  MODE: 3,
  COMPILER_INLINE_TEMPLATE: true,
  FILTERS: true,
  CONFIG_WHITESPACE: true,
  INSTANCE_SCOPED_SLOTS: true,
  INSTANCE_EVENT_EMITTER: true,
  OPTIONS_BEFORE_DESTROY: true,
  INSTANCE_LISTENERS: false, //this = true breaks Vue-Final-Modal close
  INSTANCE_EVENT_HOOKS: true,
});


/**
 * Toolkit JavaScript
 */
import { InitVue } from './vue-app.js';
import { load } from './modules/svgLoader.js';
import * as jsApps from './js-app.js';
import simpleUserApi from './utils/api/simpleUserApi.js';
import toolkitGlobal from './utils/toolkit-global.js';


//import the global cookie helper methods
//these are put directly on the window object
import "./modules/cookie.js"

//initalize js apps that don't depend on DOM Ready or personalization, only HTML parse complete
jsApps.initAllOnLoad();


//load and init sprite support
const spriteSheetURL = document.body.getAttribute("data-sprites");
if (spriteSheetURL) {
	load(spriteSheetURL);
}

//Development mode indication
if(import.meta.env.MODE === 'development'){
	console.warn("ADS Toolkit in development mode.");
}

//init apps and modules supporting Sitefinity personalization
if (window.personalizationManager) {
	window.personalizationManager.addPersonalizedContentLoaded(function () {	
    InitVue();
    jsApps.initAllAfterReady();
	});
}
else {
  InitVue();
	$(function () {
		jsApps.initAllAfterReady();
	});
}


//create a global indicating that the toolkit is loaded
//and fire a custom event that other's can listen to
//see /Content/js/toolkit-interface.js in Sitefinity for other side of this event
window.adsToolkitReady = true;
window.dispatchEvent(new CustomEvent('toolkitReady',{}));

//register the user API 
toolkitGlobal.register("userApi", simpleUserApi);

//max-width experiment
// import { init as initMaxWidthExperiment } from './experiments/max-width.js'
// initMaxWidthExperiment();


